import { useTranslation } from "react-i18next";
import Text from "../Text/Text";

const ShipSpares = () => {
  const { t } = useTranslation();

  return (
    <>
      <Text>{t("ship-spares.subtitle")}</Text>
      <Text>{t("ship-spares.description")}</Text>
      <Text>{t("ship-spares.services.service1")}</Text>
      <Text>{t("ship-spares.services.service2")}</Text>
    </>
  );
};

export default ShipSpares;
